import React from 'react';

const Ellipsis = () => (
    <>
        <span className="bg-lighterGray border border-defaultGray rounded-full lg:w-2.5 lg:h-2.5 w-1.5 h-1.5 inline-block"></span>
        <span className="bg-lighterGray border border-defaultGray rounded-full lg:w-2.5 lg:h-2.5 w-1.5 h-1.5 inline-block mx-1"></span>
        <span className="bg-lighterGray border border-defaultGray rounded-full lg:w-2.5 lg:h-2.5 w-1.5 h-1.5 inline-block"></span>
    </>
);

export default Ellipsis;
